import {useContext} from "react";
import {Sheet} from "react-modal-sheet";
import {MapContext} from "../context/MapContext";
import SettingsPanel from "./SettingsPanel";

const stackedSheetOffset = 12

const getStackedSheetSnapPoint = () => {
  const viewportHeight = window.visualViewport?.height || window.innerHeight
  const sheetHeight = viewportHeight - 34

  return (viewportHeight / 2 - stackedSheetOffset) / sheetHeight
}

const settingsSnapPoints = [0, getStackedSheetSnapPoint(), 1]

const SettingsSheet = () => {
  const {showSettings, setShowSettings} = useContext(MapContext)

  return (
    <Sheet
      isOpen={showSettings}
      onClose={() => setShowSettings(false)}
      snapPoints={settingsSnapPoints}
      initialSnap={1}
      disableScrollLocking
      style={{zIndex: 10000}}
      unstyled
    >
      <Sheet.Container className="panel settings-sheet-panel">
        <Sheet.Header className="panel-header">
          <div className="panel-grabber" aria-hidden="true"/>
        </Sheet.Header>
        <Sheet.Content className="panel-content" disableDrag>
          <main className="main-content">
            <SettingsPanel/>
          </main>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop className="settings-sheet-backdrop"/>
    </Sheet>
  )
}

export default SettingsSheet
